import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import moment from "moment";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box } from "@mui/material";
import { toastWarn } from "../../../common/Toast";

const IncomebyCustomerSummary = (props) => {
  const token = localStorage.getItem("Token");
  const gridRef = useRef();
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalexpense, setTotalexpense] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [row, setRow] = useState(false);
  const [column, setColumn] = useState(false);
  const [children, setChildren] = useState([]);
  const [reset, setReset] = useState(false);
  const [totalData, setTotalData] = useState({
    TotalIncome: 0,
    TotalExpense: 0,
    TotalNetIncome: 0,
  });

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  const options = [
    { label: "Select Period", value: 0 },
    { label: "% by row", value: 1 },
    { label: "% by column", value: 2 },
  ];

  const columns = useMemo(() => [
    {
      header: "Customer Name",
      accessorKey: "Customername",
      filterFn: "contains",
      Footer: <Box sx={{ fontWeight: "bold", padding: "8px" }}>TOTAL</Box>,
    },
    {
      header: "Income",
      accessorKey: "Income",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            window.open(
              `/profit-and-loss-detail?custid=${row.original.CustomerId}&startdate=${startdate}&enddate=${enddate}`,
              "_blank"
            ); // Open in a new tab
          }}
        >
          {CurrencySymbols(
            Number(row?.original?.Income),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
      // Cell: ({ row }) => {
      //   const TotalAmount = row?.original?.Income;
      //   return (
      //     <div style={{ textAlign: "end" }}>
      //       {CurrencySymbols(
      //         Number(TotalAmount),
      //         { CurrencySymbol },
      //         FractionDigits
      //       )}
      //     </div>
      //   );
      // },
      Footer: ({ table }) => {
        return (
          <Box sx={{  fontWeight: "bold", padding: "8px" }}>
            {/* textAlign: "right", */}
            {CurrencySymbols(
              Number(totalData.TotalIncome),
              { CurrencySymbol },
              FractionDigits
            )}
          </Box>
        );
      },
    },
    {
      header: "Expense",
      accessorKey: "Expense",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            window.open(
              `/profit-and-loss-detail?custid=${row.original.CustomerId}&startdate=${startdate}&enddate=${enddate}`,
              "_blank"
            ); // Open in a new tab
          }}
        >
          {CurrencySymbols(
            Number(row?.original?.Expense),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
      Footer: ({ table }) => {
        return (
          <Box sx={{  fontWeight: "bold", padding: "8px" }}>
            {/* textAlign: "right", */}
            {CurrencySymbols(
              Number(totalData.TotalExpense),
              { CurrencySymbol },
              FractionDigits
            )}
          </Box>
        );
      },
    },
    {
      header: "Net Income",
      accessorKey: "NetIncome",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            textAlign: "right",
            // alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            window.open(
              `/profit-and-loss-detail?custid=${row.original.CustomerId}&startdate=${startdate}&enddate=${enddate}`,
              "_blank"
            ); // Open in a new tab
          }}
        >
          {CurrencySymbols(
            Number(row?.original?.NetIncome),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
      Footer: ({ table }) => {
        return (
          <Box sx={{ fontWeight: "bold", padding: "8px" }}>
            {/* textAlign: "right", */}
            {CurrencySymbols(
              Number(totalData.TotalNetIncome),
              { CurrencySymbol },
              FractionDigits
            )}
          </Box>
        );
      },
    },
  ]);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const paramObject = useParams();

  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    setLoading(true);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/incomebycustomersummary?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const FilterData = res.data.ResponseData?.map((el) => ({
              ...el,
              Customername: String(el.Customername),
              Income: Number(el?.Income) || 0,
              Expense: Number(el?.Expense) || 0,
              NetIncome: Number(el?.NetIncome) || 0,
            }));
            setResponseData(FilterData);
            setTotalData({
              ...totalData,
              TotalIncome: FilterData.reduce(
                (sum, item) => sum + (parseFloat(item.Income) || 0),
                0
              ),
              TotalExpense: FilterData.reduce(
                (sum, item) => sum + (parseFloat(item.Expense) || 0),
                0
              ),
              TotalNetIncome: FilterData.reduce(
                (sum, item) => sum + (parseFloat(item.NetIncome) || 0),
                0
              ),
            });
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // const onGridReady = useCallback((params) => {
  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/incomebycustomersummary?startdate=${""}&enddate=${""}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log("res.data.ResponseData 270", res.data.ResponseData);
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         console.log("11", responseData);
  //         //   barcodeRefs.current = responseData;
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, []);

  // const autoGroupColumnDef = useMemo(() => {
  //   return {
  //     minWidth: 300,

  //   };
  // }, []);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Income by Customer Summary
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Income by Customer Summary
                    </p>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Income By Customer Summary"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                    enableRowSelection={false}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default IncomebyCustomerSummary;
